import { render } from "./LostReasonDetailSelect.vue?vue&type=template&id=04671250"
import script from "./LostReasonDetailSelect.vue?vue&type=script&lang=js"
export * from "./LostReasonDetailSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__